import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ isAuthenticated = false, onMenuToggle }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container-fluid px-4">
        {isAuthenticated && (
          <button className="btn btn-link nav-menu-toggle d-lg-none" onClick={onMenuToggle}>
            <i className="bi bi-list"></i>
          </button>
        )}

        <Link className="navbar-brand" to="/">
          <span className="brand-text">ANTIPSUN</span>
        </Link>

        {!isAuthenticated ? (
          <>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#about">About</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#features">Features</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#roadmap">Roadmap</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#faq">FAQ</a>
                </li>
              </ul>

              <div className="ms-3 d-flex gap-2">
                <Link to="/login" className="btn btn-outline-gradient">Login</Link>
                <Link to="/register" className="btn btn-gradient">Register</Link>
              </div>
            </div>
          </>
        ) : (
          <div className="ms-auto d-flex align-items-center gap-3">
            {/* <div className="nav-wallet">
              <i className="bi bi-wallet2"></i>
              <span className="ms-2">$12,345.67</span>
            </div> */}

            {/* <div className="nav-notifications">
              <button className="btn btn-link position-relative">
                <i className="bi bi-bell"></i>
                <span className="notification-badge">3</span>
              </button>
            </div> */}

            <div className="dropdown">
              <button className="btn btn-link dropdown-toggle nav-user" data-bs-toggle="dropdown">
                <img src="https://ui-avatars.com/api/?name=John+Doe&background=1ED760&color=071B12" alt="User" className="user-avatar" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li><Link className="dropdown-item" to="/dashboard/profile"><i className="bi bi-person me-2"></i>Profile</Link></li>
                <li><Link className="dropdown-item" to="/dashboard/settings"><i className="bi bi-gear me-2"></i>Settings</Link></li>
                <li><hr className="dropdown-divider" /></li>
                <li><Link className="dropdown-item" to="/logout"><i className="bi bi-box-arrow-right me-2"></i>Logout</Link></li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;